import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CheckIn from "../../../components/Modal/Admin/InventoryManagement/CheckIn";
import axiosInstance from "../../../hooks/axiosInstance";
import { toast } from "react-toastify";
import { Oval } from "react-loader-spinner";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import EditCheckIn from "../../../components/Modal/Admin/InventoryManagement/EditCheckIn";



export default function CheckinPage() {
  const MySwal = withReactContent(Swal);

  const [Checkin, setCheckin] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({});
  const [page, setPage] = useState(1);
  const [refreshKey, setRefreshKey] = useState(0);
  const [filter, setFilter] = useState("");
  const [showCheckin, setShowCheckin] = useState(false);
  const [editCheckin, setEditCheckIn] = useState(null);
  const [showEdit, setShowEdit] = useState(false);






  useEffect(() => {
    const ftechCheckIn = async () => {
      setLoading(true);

      try {
        const response = await axiosInstance.get(
          `/user/check_in/fetch_checkin`,
          {
            params: {
              page,
              filter,
            },
          }
        );

        setCheckin(response.data.data.checkIn.data || []);
        setPagination(response.data.data.checkIn);
      } catch (error) {
        toast.error("Error fetching users:", error);
      }
      finally {
        setLoading(false); // Hide loader after fetching
      }
    };

    ftechCheckIn();
  }, [page, filter, refreshKey]);



  const handleShowCheckin = () => setShowCheckin(true);

  const handleClose = () => {
    setShowCheckin(false);
    setShowEdit(false)
  };
  const handleRefresh = () => {
    setRefreshKey((prevRefreshKey) => prevRefreshKey + 1);
  };
  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= pagination.last_page) {
      setPage(newPage);
    }
  };

  const handleShowEdit = (id) => {
    setEditCheckIn(id);
    setShowEdit(true);

  };

  const handleDelete = async (check_in_id) => {
    const result = await MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axiosInstance.post(
          `/user/check_in/remove-checkIn/${check_in_id}`
        );
        handleRefresh();
        handleClose();
        toast.success("Customer removed successfully!");
      } catch (error) {
        toast("Error deleting customer:", error);
      }
    }
  };

  useEffect(() => { }, [refreshKey]);

  return (
    <>
      {/* <!-- start page title --> */}
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0" style={{ color: "#c4281c" }}>
              Check-In Management
            </h4>

            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="/app">Dashboard</Link>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "#c4281c" }}
                >
                  Check-In Management
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- end page title --> */}

      {loading && !filter ? ( // Only show loader for general data fetching
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "80vh" }}
        >
          <Oval
            height={80}
            width={80}
            color="#FF0200"
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#4fa94d"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      ) : (

        <div className="row" id="contactList">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header d-flex align-items-center border-0">
                <h5
                  className="card-title mb-0 flex-grow-1"
                  style={{ color: "#c4281b" }}
                >
                  Check-In Management
                </h5>
              </div>

              <div className="d-flex justify-content-end">
                <div className="col-xl-2 col-md-4" style={{ marginRight: "2px" }}>
                  <button
                    className="vehicle-button btn btn-primary"
                    onClick={handleShowCheckin}
                  >
                    <i className="mdi mdi-plus-circle-outline"></i> Check-In
                  </button>
                </div>
              </div>

              <div className="card-body border border-dashed border-end-0 border-start-0">
                <div className="d-flex justify-content-between">
                  <div className="col-xl-4 col-md-6">
                    <div className="search-box">
                      <input
                        type="text"
                        className="form-control search"
                        placeholder="Search product..."
                        value={filter}
                        onChange={handleFilterChange}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-body">
                <div className="table-responsive table-card">
                  <table
                    className="table align-middle table-nowrap table table-striped table-borderless table-hover"
                    id="customerTable"
                  >
                    <thead className="table-light text-muted">
                      <tr>
                        <th scope="col">#</th>
                        <th>Category</th>
                        <th>Sub category</th>
                        <th>Product Name</th>
                        <th>Warehouse</th>
                        <th>Production Date</th>
                        <th>Batch Number</th>
                        <th>Quantity</th>
                      </tr>
                    </thead>
                    {/* <!--end thead--> */}
                    <tbody className="list form-check-all">
                      {Checkin.map((item, index) => (
                        <tr key={item.id}>
                          <td scope="row">{index + 1}</td>
                          <td>{item.category_name}</td>
                          <td>{item.sub_category_name}</td>
                          <td>{item.product_name}</td>
                          <td>{item.ware_house_name}</td>
                          <td>{item.production_date}</td>
                          <td>{item.batch_number}</td>
                          <td>{item.quantity}</td>
                          <td>
                            <div className="dropdown">
                              <button
                                className="btn btn-icon btn-sm fs-16 text-muted dropdown"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i className="mdi mdi-apps"></i>
                              </button>
                              <ul className="dropdown-menu">
                                <li>
                                  <Link
                                    className="dropdown-item"
                                    onClick={() => handleShowEdit(item)}
                                  >
                                    <i className="mdi mdi-pencil me-2 text-success"></i>{" "}
                                    Edit
                                  </Link>
                                </li>

                                <li>
                                  <Link
                                    className="dropdown-item"
                                    onClick={() =>
                                      handleDelete(item.id)
                                    }
                                  >
                                    <i className="mdi mdi-trash-can-outline me-2 text-danger"></i>
                                    Delete Check-In
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {/* <!--end table--> */}
                    <div className="d-flex mt-5 mb-5 flex-wrap">
                      <div className="pagination-wrap hstack gap-2 mx-auto">
                      <ul className="pagination listjs-pagination mb-0">
                        {(pagination.links || []).map((link, index) => {
                          const pageNumber = link.url
                            ? new URL(link.url).searchParams.get("page")
                            : null;

                          return (
                            <li
                              key={index}
                              className={`page-item ${link.active ? "active" : ""
                                }`}
                            >
                              <button
                                className="page-link"
                                onClick={() =>
                                  pageNumber &&
                                  handlePageChange(Number(pageNumber))
                                }
                                dangerouslySetInnerHTML={{ __html: link.label }}
                              ></button>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <CheckIn
            showCheckin={showCheckin}
            closeModal={handleClose}
            refreshPage={handleRefresh}
            />
            <EditCheckIn
              showEdit={showEdit}
              closeModal={handleClose}
              refreshPage={handleRefresh}
              CheckInData={editCheckin}

            />
        </div>
      )}
    </>
  );
}
